module.exports = __webpack_public_path__ + "img/mc_logo.6d00e195.png";